export enum UserTypes {
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT'
}
